import { Component, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-set-up-delivery-here',
  standalone: true,
  imports: [RouterLink],
  templateUrl: './set-up-delivery-here.component.html',
  styleUrl: './set-up-delivery-here.component.scss'
})
export class SetUpDeliveryHereComponent {

  #activeModal = inject(NgbActiveModal);

  close() {
    this.#activeModal.close();
  }
}
